/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_Adsense_TitleInputs */

const en_admin_settings_groups_adsense_title = /** @type {(inputs: Admin_Settings_Groups_Adsense_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google AdSense`)
};

/**
* | output |
* | --- |
* | "Google AdSense" |
*
* @param {Admin_Settings_Groups_Adsense_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_adsense_title = /** @type {((inputs?: Admin_Settings_Groups_Adsense_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_Adsense_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_groups_adsense_title(inputs)
});
export { admin_settings_groups_adsense_title as "admin.settings.groups.adsense.title" }